module.exports = __webpack_public_path__ + "media/src/images/icons/asterisk-baf8f8f63cb1e45fdb293048053798fb.svg";